import styled from 'styled-components';

import media from 'styled-media-query';

import { Media } from '../../../styles/constants';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 40px;

    img {
      width: 428px;
      height: 267px;
      margin-top: 25px;
    }

    h1 {
      font: Bold 85px/102px Roboto;
      color: #0052cc;
    }

    h2 {
      font: Regular 31px/37px Roboto;
      letter-spacing: 0;
      color: #42526e;
      margin-top: 10px;
      opacity: 1;
    }
    ${media.lessThan(`${Media.md}px`)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 40px;

    img {
      width: 328px;
      height: 167px;
      margin-top: 15px;
    }

    h1 {
      font-size:2.5em;
      color: #0052cc;
    }

    h2 {
      font-size:1.3em;
      letter-spacing: 0;
      color: #42526e;
      width:100%;
      opacity: 1;
    }

    button{
      width:340px;
      font-size:10px;
    }

  `}
  }
`;

export const DivText = styled.div``;
